/**
 * Created by mateimisarca on 11/03/2018
 */

import DropdownMenu from './dropdown-menu';

export default DropdownMenu;
